/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ price: NonNullable<unknown> }} Seo_Price_CheapestInputs */

const en_seo_price_cheapest = /** @type {(inputs: Seo_Price_CheapestInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.price} on the cheapest endpoint`)
};

const zh_hans1_seo_price_cheapest = /** @type {(inputs: Seo_Price_CheapestInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.price}（最便宜的接口）`)
};

const pt_br2_seo_price_cheapest = /** @type {(inputs: Seo_Price_CheapestInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.price} no endpoint mais barato`)
};

const es_seo_price_cheapest = /** @type {(inputs: Seo_Price_CheapestInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.price} en el endpoint más barato`)
};

const fr_seo_price_cheapest = /** @type {(inputs: Seo_Price_CheapestInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.price} sur l’endpoint le moins cher`)
};

const de_seo_price_cheapest = /** @type {(inputs: Seo_Price_CheapestInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.price} beim günstigsten Endpoint`)
};

const ru_seo_price_cheapest = /** @type {(inputs: Seo_Price_CheapestInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.price} на самом дешёвом эндпоинте`)
};

const it_seo_price_cheapest = /** @type {(inputs: Seo_Price_CheapestInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.price} sull'endpoint più economico`)
};

/**
* | output |
* | --- |
* | "{price} on the cheapest endpoint" |
*
* @param {Seo_Price_CheapestInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const seo_price_cheapest = /** @type {((inputs: Seo_Price_CheapestInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_Price_CheapestInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_seo_price_cheapest(inputs)
	if (locale === "pt-BR") return pt_br2_seo_price_cheapest(inputs)
	if (locale === "es") return es_seo_price_cheapest(inputs)
	if (locale === "fr") return fr_seo_price_cheapest(inputs)
	if (locale === "de") return de_seo_price_cheapest(inputs)
	if (locale === "ru") return ru_seo_price_cheapest(inputs)
	if (locale === "it") return it_seo_price_cheapest(inputs)
	return en_seo_price_cheapest(inputs)
});